import React from 'react';
import { observer } from 'mobx-react';
import { Catcher, ListWrapper, ReportFilesToolBar } from '../';
import { CustomFilterExport } from '../CustomFilterExport';
import { appConfig } from '../../settings';
import { useCallDataRecordsFilterParamsBeta, useProfile, useProfileFeatureFlags, useProfileIsRight } from '../../hooks';
import { cleanCallDataRecordsRelationSelectAndStoreBeta, getCallDataRecordsRelationSelect } from '../../middleware';
import { CallDataRecordsBetaTableList } from './Components';

const ReportToolBar: React.FC = observer(() => {
    const { isCompanyTypeIdMNOHost } = useProfile();
    const filterParams = useCallDataRecordsFilterParamsBeta();
    return (
        <Catcher>
            <CustomFilterExport
                filterParams={filterParams}
                exportButtons={
                    <ReportFilesToolBar
                        filterParams={filterParams}
                        entityType={'squashed'}
                        type={'POST_CALL_DATA_RECORDS'}
                        isPdf={!isCompanyTypeIdMNOHost}
                        isCsv={true}
                    />
                }
            />
        </Catcher>
    );
});

export const CallDataRecordsListBeta: React.FC = observer(() => {
    const filterParams = useCallDataRecordsFilterParamsBeta();
    const { companyId } = useProfile();
    const isLord = useProfileIsRight('LORD');
    const newChargingSystem = useProfileFeatureFlags().newChargingSystem;

    return (
        <Catcher>
            <ListWrapper
                cleanStore={cleanCallDataRecordsRelationSelectAndStoreBeta}
                defaultParams={{ companyId }}
                filterParams={filterParams}
                getRelationSelect={getCallDataRecordsRelationSelect}
                RightButtons={ReportToolBar}
                months={
                    newChargingSystem && !isLord
                        ? appConfig.maximumMonthsForRequestForCDRs
                        : appConfig.maximumMonthsForRequest
                }
            >
                <CallDataRecordsBetaTableList />
            </ListWrapper>
        </Catcher>
    );
});
